import React, { useEffect, useState } from 'react';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { Button, CardTitle } from 'components';
import { Divider } from '@mui/material';


const CollapsibleSection = ({
  children,
  title,
  buttonText = 'Expand',
  collapsTrigger = false,
  underLineVisible = true,
  showButton = true,
}) => {
  const [open, setOpen] = useState(collapsTrigger);

  const handleToggle = () => setOpen((prev) => !prev);

  useEffect(() => {
    setOpen(collapsTrigger);
  }, [collapsTrigger]);

  return (
    <Box width="100%">
      <Box justifyContent="space-between" alignItems="center">
       <CardTitle>{title}</CardTitle>

        {showButton && (
        <div className='w-full flex justify-end'>
          <Button
            variant="outlined"
            startIcon={open ? <ExpandLess /> : <ExpandMore />}
            onClick={handleToggle}
          >
            {buttonText}
          </Button>
        </div>
        )}

      </Box>
      {underLineVisible && (
        <Divider sx={{ width: '100%', my: 1 }} />
      )}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box>
          {children}
        </Box>
        <Divider sx={{ width: '100%', my: 2 }} />
      </Collapse>
    </Box>
  );
};

export default CollapsibleSection; 